import React, { useContext, useEffect, useRef, useState } from "react";
import FunticoLogo from "/components/core/Logo";
import AuthContext from "/context/AuthProvider";
import UnLoginedButton from "/components/core/HeaderNavButtons";
import { startScroll, stopScroll } from "/utils/scroll-config";
import { useWindowScroll } from "/utils/hooks/use-EventListener";
import DelayLink from "../core/DelayLink";
import { funticoUrl, aboutUrl, faqUrl } from "/utils/links";
import { loadHubSpot } from "/utils/utils";

const pages = [
  { to: `${aboutUrl}/`, title: "About us" },
  { to: `${funticoUrl}/join`, title: "Join Community" },
  { to: `${faqUrl}/`, title: "FAQ" },
];

export default function Aside({ state, openNav, isOpen, logos }) {
  const overflow = useRef(null);
  const { auth } = useContext(AuthContext);
  const scrollY = useWindowScroll();
  const showNavigation = state.getState().showNavigation;

  useEffect(() => {
    overflow && isOpen && overflow.current.scrollTo(0, 0);
    if (isOpen) stopScroll(scrollY);
    return () => {};
  }, [isOpen]);

  return showNavigation ? (
    <aside className={isOpen ? "active" : ""}>
      <div className="top df jc-c">
        <div className="select-logo df">
          <img src={"/logo-sports.png"} alt="Sports" />
        </div>

        <button
          className="close_mob close_icon"
          onClick={(e) => {
            openNav(false);
            startScroll();
          }}
        ></button>
      </div>

      <div className="overflow df fd-c " ref={overflow}>
        <nav className="nav df fd-c ">
          <UnLoginedButton state={state} auth={auth}>
            {""}
          </UnLoginedButton>
        </nav>

        <div className="selecting df fd-c ai-c">
          <div className="select df ai-c w-full">
            <div className="line"></div>
            <span>SWITCH TO</span>
            <div className="mask_switch icon_16"></div>
            <div className="line"></div>
          </div>
          {logos.map((logo, i) => (
            <a href={logo.link} className="df select-logo" key={i}>
              <img src={logo.img} alt="" />
            </a>
          ))}
        </div>

        <div className="pages df ai-c fd-c">
          {pages.map((l) => (
            <a
              key={l.to}
              href={l.to}
              className="l fixel_16_sbl op"
              target="_blank"
              rel="noreferrer"
            >
              {l.title}
            </a>
          ))}
          <button className="l fixel_16_sbl op" onClick={loadHubSpot}>
            Contact Us
          </button>
        </div>
      </div>
    </aside>
  ) : null;
}
